export const approveConstants = {
    GET_SUCCESS: 'GET_APPROVE_SUCCESS',
    GET_FAILURE: 'GET_APPROVE_FAILURE',

    CLEAR_ERROR: 'CLEAR_ERROR_CODE'
};
